import "core-js/modules/es6.function.name";

/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;
/* eslint-disable import/no-cycle */


import TypeSignature from './JsDocTypeSignature';

var JsDocTitleSignature = function JsDocTitleSignature(_ref) {
  var definition = _ref.definition,
      title = _ref.title,
      _ref$showSignature = _ref.showSignature,
      showSignature = _ref$showSignature === void 0 ? true : _ref$showSignature,
      _ref$ignoreParams = _ref.ignoreParams,
      ignoreParams = _ref$ignoreParams === void 0 ? [] : _ref$ignoreParams,
      className = _ref.className;

  if (!title && definition.name) {
    title = _j("code", null, definition.name, definition.optional && '?');
  }

  return _j("div", {
    className: className,
    css: [require("./JsDocTitleSignature-CssProp1_div.module.css"), []]
  }, title, showSignature && _j(TypeSignature, {
    definition: definition,
    ignoreParams: ignoreParams
  }));
};

export default JsDocTitleSignature;
export var fragment = "2842186527";